import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  getImpersonationReturnToken,
  clearImpersonationReturnToken,
  hasImpersonationReturnToken,
  loginWithJwt,
} from "../../api/StorageApi";
import { LogOut } from "lucide-react";

/**
 * Shown when the user is in the main app via "Login as" (impersonation).
 * Lets them exit and return to their original admin session.
 */
export default function ImpersonationBanner() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(hasImpersonationReturnToken());
  }, []);

  const handleExit = useCallback(() => {
    const returnData = getImpersonationReturnToken();
    if (!returnData?.jwt) return;
    loginWithJwt(returnData.jwt);
    clearImpersonationReturnToken();
    // Pass admin JWT in URL so admin app can restore session (handles separate bundle/origin)
    const returnUrl = `/admin?jwt=${encodeURIComponent(returnData.jwt)}`;
    window.location.href = returnUrl;
  }, []);

  if (!show) return null;

  return (
    <div
      className="flex items-center justify-center gap-3 bg-amber-50 border-b border-amber-200 px-4 py-2 text-sm text-amber-900"
      role="banner"
    >
      <span>{t("You are viewing as this user.")}</span>
      <button
        type="button"
        onClick={handleExit}
        className="inline-flex items-center gap-1.5 rounded-md bg-amber-100 px-2.5 py-1 font-medium text-amber-800 hover:bg-amber-200 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1"
      >
        <LogOut className="h-3.5 w-3.5" />
        {t("Exit login as")}
      </button>
    </div>
  );
}
